<template>
<el-dialog
    class="rename-tag-div dialog-body-wrap zimbra-dialog zimbra-limited-width-dialog"
    :title="$t('zimbra.zmMsg.editTag')"
    :visible.sync="dialogEditTag"
    width="480px"
    :append-to-body="true"
    :close-on-click-modal="false">
        <el-form class="form-wrap">
            <div class="mb-8">
                <span>{{ $t("zimbraNokey.zimbra_sidebar_dialogReNameTag_tagName") }}</span>
            </div>
            <el-row :gutter="10">
                <el-col :span="12">
                    <el-input
                        v-model="newName"
                        autocomplete="off"
                        size="medium"
                        class="el-text-control"
                        @change="changeNewName"
                    ></el-input>
                </el-col>
                <el-col :span="8" style="padding-left: 123px; padding-right: 5px;">
                    <zm-color-picker
                        class="zm-color-picker-custom"
                        v-model="rgb"
                        :visible="false"
                        :showFooter="true"
                        :default-colors="['#3F4254', '#0000FF', '#00FFFF', '#008000', '#FF00FF', '#FF0000', '#FFFF00', '#FF66FF', '#808080', '#FF9900']"
                    >
                    </zm-color-picker>
                </el-col>
            </el-row>

        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogEditTag = false">{{
                  $t("zimbra.zhMsg.actionTaskCancelTT")
              }}</el-button>
          <el-button type="primary" @click="reNameTag">{{
                  $t("zimbra.zmMsg.mobileStatusNeedProvision")
              }}</el-button>
        </span>
      </el-dialog>
</template>

<script>
import ZimbraMailService from "@/services/ZimbraMailService.js";
import CommonUtils from "@/utils/common-utils";
import { mapGetters } from "vuex";
import { STATUS_REQUEST, READ_EMAIL_LAYOUT_ROUTER } from "@/utils/constants";
import _ from "lodash";
import $ from 'jquery';
import ZmColorPicker from "../../base/base-color-picker-advance/zm-color-picker.vue";
export default {
    mixins: [CommonUtils],
    computed: {
        ...mapGetters(["tags", "listTag"]),
    },
    mounted() {
        this.$root.$on("handleTagActionEditTag", (data) => {
            this.show(data);
        });
    },
    data() {
        return {
            treeNodeData: {},
            newName: "",
            rgb: "#3F4254",
            dialogEditTag: false,
            showPickerColor: false,
        };
    },
    components: {
        "zm-color-picker": ZmColorPicker
    },
    methods: {
        show(data) {
            this.treeNodeData = data;
            this.newName = this.treeNodeData.name;
            this.rgb = data.rgb || "#3F4254";
            this.dialogEditTag = true;
            // Cách first focus input
            $(document).ready(function () {
                setTimeout(function () {
                    const divMainContract = $(".rename-tag-div");
                    const firstInput = $(":input:not(input[type=button],input[type=submit],button):visible:first", divMainContract);
                    firstInput.focus();
                }, 500);
            });
            const { name } = this.$route;
            if (name == READ_EMAIL_LAYOUT_ROUTER.NAME_HIDE) {
                this.isMessage = true
            } else {
                this.isMessage = false
            }
        },
        reNameTag() {
            this.newName = this.newName.toString().trim();
            if (
                this.newName === "" ||
                this.newName.length > 128 ||
                this.newName.indexOf("/") > -1
            ) {
                const nameError = _.escape(this.newName);
                const Msgerror =
                    this.newName === ""
                        ? this.$t("zimbra.zmMsg.nameEmpty")
                        : this.newName.length > 128
                            ? this.$t("zimbra.zhMsg.nameTooLong", { 0: 128 })
                            : this.$t(
                                "zimbra.zmMsg.errorInvalidName",
                                { 0: nameError }
                            );
                this.$alert(Msgerror, this.$t("zimbraNokey.zimbra_sidebar_criticalMsg"), {
                    confirmButtonText: this.$t("zimbra.zmMsg.mobileStatusNeedProvision"),
                    customClass: "notification-error-tag",
                    type: "error"
                });
                return;
            }
            if (this.newName.toLowerCase() != this.treeNodeData.name.toString().toLowerCase()) {
                if (this.checkExistsName(this.newName)) {
                    return;
                }
            }
            const id = this.treeNodeData.id;
            const newName = _.escape(this.newName)
            const rgb = this.rgb;

            // const formName = {
            //     tag: `<urn1:action id="${id}" op="rename" name="${newName}"></urn1:action>`,
            // };
            // const formColor = {
            //     tag: `<urn1:action id="${id}" op="color" rgb="${rgb}"></urn1:action>`,
            // };
            const form = {
                tag: `
                    <urn1:action id="${id}" op="rename" name="${newName}"></urn1:action>
                    <urn1:action id="${id}" op="color" rgb="${rgb}"></urn1:action>
                    `
            };
            ZimbraMailService.tagActionRequest(form).then((res) => {
                console.log(res);
                if (res.status === STATUS_REQUEST.SUCCESS) {
                    // ZimbraMailService.tagActionRequest(formColor).then((res) => {
                    //     if (res.status === STATUS_REQUEST.SUCCESS) {
                    //         if (this.isMessage) {
                    //             this.$message({
                    //                 type: "success",
                    //                 customClass: 'zm-notify',
                    //                 duration: 3500,
                    //                 dangerouslyUseHTMLString: true,
                    //                 message: this.$t("zimbraNokey.zimbra_sidebar_messageSuccessChangeColorTag")
                    //             });
                    //         } else {
                    //             this.$notify({
                    //                 title: this.$t("zimbra.zmMsg.dataSourceTestSuccess"),
                    //                 message: this.$t("zimbraNokey.zimbra_sidebar_messageSuccessChangeColorTag"),
                    //                 type: "success",
                    //             });
                    //         }
                    //
                    //         this.treeNodeData.rgb = this.rgb;
                    //         this.$store.commit("SET_TAGS", this.treeNodeData);
                    //     }
                    // });
                    if (this.isMessage) {
                        this.$message({
                            type: "success",
                            customClass: 'zm-notify',
                            duration: 3500,
                            dangerouslyUseHTMLString: true,
                            message: this.$t("zimbraNokey.zimbra_sidebar_messageSuccessReNameTag"),
                        });
                    } else {
                        this.$notify({
                            title: this.$t("zimbra.zmMsg.dataSourceTestSuccess"),
                            message: this.$t("zimbraNokey.zimbra_sidebar_messageSuccessReNameTag"),
                            type: "success",
                        });
                    }
                }
                this.tags.name = this.newName;
                this.treeNodeData.rgb = this.rgb;
                this.$store.commit("SET_TAGS", this.treeNodeData);
                console.log(this.tags.name);
                // console.log(this.tags.rgb);
                this.$store.commit("SET_TAGS", this.tags);
                this.showPickerColor = false;

            });
            this.dialogEditTag = false;
        },
        changeNewName() {
            this.newName = this.newName ? this.newName.trim() : '';
        },
        checkExistsName(name) {
            if (this.listTag) {
                if (this.listTag.map(x => x.name.toString().toLowerCase()).indexOf(name.toString().toLowerCase()) > -1) {
                    this.$alert(
                        this.$t("zimbra.zmMsg.tagNameExists", {
                            name: name
                        }),
                        this.$t("zimbraNokey.zimbra_sidebar_criticalMsg"),
                        {
                            confirmButtonText: this.$t("zimbra.zmMsg.mobileStatusNeedProvision"),
                            type: "error"
                        }
                    );
                    return true;
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.mb-8 {
    margin-bottom: 8px;
}

.label-custom {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
}

.zm-color-picker-custom{
    ::v-deep {
        .el-input__inner{
            border: 1px solid #ffffff;
        }
    }
}
</style>
